<template>
    <label class="relative inline-flex items-center cursor-pointer group">
        <input
            type="checkbox"
            class="sr-only peer"
            :disabled="disabled"
            @change="trigger"
            :checked="value"
        />
        <div
            :class="[
                'w-11 h-6 bg-gray-100 peer-focus:outline-none rounded-full peer transition-all',
                'peer-checked:after:translate-x-full peer-checked:after:border-white',
                'after:content-[\'\'] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-100 after:border after:rounded-full after:h-5 after:w-5 after:transition-all after:shadow-sm',
                checkedTrackClass,
                disabled ? 'opacity-50 cursor-not-allowed' : '',
            ]"
        ></div>
        <span
            v-if="shouldShowLabel"
            class="ml-3 text-[11px] font-bold text-primary uppercase tracking-wider"
        >
            <span v-if="label" v-text="label"></span>
            <span v-if="!label && value" v-text="textEnabled"></span>
            <span v-if="!label && !value" v-text="textDisabled"></span>
        </span>
    </label>
</template>

<script>
export default {
    name: "Switches",

    props: {
        typeBold: { default: false },
        value: { default: false },
        disabled: { default: false },
        label: { default: "" },
        textEnabled: { default: "" },
        textDisabled: { default: "" },
        color: { default: "primary" },
        theme: { default: "default" },
        emitOnMount: { default: true },
    },

    mounted() {
        if (this.emitOnMount) {
            this.$emit("input", this.value);
        }
    },

    methods: {
        trigger(e) {
            this.$emit("input", e.target.checked);
        },
    },

    computed: {
        checkedTrackClass() {
            const colorMap = {
                primary: 'peer-checked:bg-primary',
                blue: 'peer-checked:bg-blue-500',
                secondary: 'peer-checked:bg-secondary',
                purple: 'peer-checked:bg-purple-500',
                red: 'peer-checked:bg-red-500',
                green: 'peer-checked:bg-emerald-500',
            };

            return colorMap[this.color] || colorMap.primary;
        },
        shouldShowLabel() {
            return (
                this.label !== "" ||
                this.textEnabled !== "" ||
                this.textDisabled !== ""
            );
        },
    },
};
</script>
